import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import MainContext from "./context/MainContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <MainContext>
        <App />
      </MainContext>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
